import { createFileRoute } from "@tanstack/react-router";
import { redirect } from "../../../../../scaffolding/router-api";

export const Route = createFileRoute("/_auth/_organisation/organisation/resources/")({
  beforeLoad: () => {
    throw redirect({ to: "/organisation/resources/labor", replace: true });
  },
});
